"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyDiscount = exports.findMatchingDiscount = exports.findMatchingSize = exports.round = exports.quotedPriceBuild = exports.normalizeMaterialSize = exports.calculatePricing = exports.applyDiscountToMaterial = exports.findTaxRate = exports.salesTax = exports.VERSION = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
exports.VERSION = 1;
exports.salesTax = [
    { state: 'AL', amount: 0.0 },
    { state: 'AK', amount: 0.0 },
    { state: 'AZ', amount: 0.0 },
    { state: 'AR', amount: 0.0 },
    { state: 'CA', amount: 0.0 },
    { state: 'CO', amount: 0.0 },
    { state: 'CT', amount: 0.0635 },
    { state: 'DE', amount: 0.0 },
    { state: 'DC', amount: 0.0 },
    { state: 'FL', amount: 0.0 },
    { state: 'GA', amount: 0.0 },
    { state: 'HI', amount: 0.0 },
    { state: 'ID', amount: 0.0 },
    { state: 'IL', amount: 0.0 },
    { state: 'IN', amount: 0.0 },
    { state: 'IA', amount: 0.0 },
    { state: 'KS', amount: 0.0 },
    { state: 'KY', amount: 0.0 },
    { state: 'LA', amount: 0.0 },
    { state: 'ME', amount: 0.0 },
    { state: 'MD', amount: 0.0 },
    { state: 'MA', amount: 0.0 },
    { state: 'MI', amount: 0.0 },
    { state: 'MN', amount: 0.0 },
    { state: 'MS', amount: 0.0 },
    { state: 'MO', amount: 0.0 },
    { state: 'MT', amount: 0.0 },
    { state: 'NE', amount: 0.0 },
    { state: 'NV', amount: 0.0 },
    { state: 'NH', amount: 0.0 },
    { state: 'NJ', amount: 0.06625 },
    { state: 'NM', amount: 0.0 },
    { state: 'NY', amount: 0.0 },
    { state: 'NC', amount: 0.0 },
    { state: 'ND', amount: 0.0 },
    { state: 'OH', amount: 0.0 },
    { state: 'OK', amount: 0.0 },
    { state: 'OR', amount: 0.0 },
    { state: 'PA', amount: 0.0 },
    { state: 'RI', amount: 0.0 },
    { state: 'SC', amount: 0.0 },
    { state: 'SD', amount: 0.0 },
    { state: 'TN', amount: 0.0 },
    { state: 'TX', amount: 0.0 },
    { state: 'UT', amount: 0.0 },
    { state: 'VT', amount: 0.0 },
    { state: 'VA', amount: 0.0 },
    { state: 'WA', amount: 0.0 },
    { state: 'WV', amount: 0.0 },
    { state: 'WI', amount: 0.0 },
    { state: 'WY', amount: 0.0 },
];
const priceTypesEnums = {
    ton: 'ton',
    yard: 'yard',
    flat: 'flat',
    tonVariableHaul: 'tonVariableHaul',
};
const round = (number, radix = 1) => {
    const modulus = number % radix;
    const rounded = number - modulus;
    if (modulus >= radix / 2) {
        return rounded + radix;
    }
    return rounded;
};
exports.round = round;
const nextDollar = (price) => {
    const radix = 100;
    const modulus = price % radix;
    const rounded = price - modulus;
    if (modulus > 0) {
        return rounded + radix;
    }
    return rounded;
};
const findTaxRate = (state) => {
    const found = exports.salesTax.find((item) => item.state === state);
    if (found)
        return found.amount;
    return 0;
};
exports.findTaxRate = findTaxRate;
const normalizeSize = (material, size) => {
    let multiplier;
    switch (material.type) {
        case priceTypesEnums.ton:
            multiplier = size.tonLimit || 0;
            break;
        case priceTypesEnums.yard:
            multiplier = Number(size.size) || 0;
            break;
        case priceTypesEnums.flat:
            multiplier = 0;
            break;
        case priceTypesEnums.tonVariableHaul:
            multiplier = size.tonLimit || 0;
            break;
        default:
            multiplier = 0;
            break;
    }
    return {
        dump: +(size.dump || 0),
        tax: material.tax,
        size: Number(size.size),
        type: material.type,
        haul: size.haul,
        tonLimit: size.tonLimit || 0,
        overage: size.over || 0,
        multiplier,
    };
};
const normalizeMaterialSize = (material) => {
    const sizes = material.sizes.map((size) => normalizeSize(material, size));
    return {
        material: material.material,
        tax: material.tax,
        type: material.type,
        sizes,
        doesNotService: material.doesNotService,
        allowOnlineCheckout: material.allowOnlineCheckout,
    };
};
exports.normalizeMaterialSize = normalizeMaterialSize;
const quotedPriceBuild = (tonLimit, dumpRate, haulRate, taxRate, ccRate, roundTotal, over) => {
    // console.log(tonLimit, dumpRate, haulRate, taxRate, ccRate, roundTotal, over);
    const dumpFinal = dumpRate * tonLimit;
    const taxHaul = round(haulRate * taxRate);
    const overage = nextDollar((over || dumpRate) / (1 - ccRate));
    const rawTotal = (haulRate + dumpFinal + taxHaul) / (1 - ccRate);
    if (!roundTotal) {
        return {
            haul: haulRate,
            dump: dumpFinal,
            tax: round(taxHaul),
            cc: round(rawTotal * ccRate),
            total: round(rawTotal),
            overage: round(overage),
            totalWithoutTax: round(rawTotal - round(taxHaul)),
            tonLimit: tonLimit,
            version: exports.VERSION,
        };
    }
    // const total = Math.ceil(rawTotal);
    const total = Math.ceil(rawTotal / 500) * 500;
    const ccFinal = total * ccRate;
    const haulWTax = total - dumpFinal - ccFinal;
    const haulFinal = haulWTax / (1 + taxRate);
    const taxFinal = haulWTax - haulFinal;
    // console.log('haulFinal', haulFinal);
    return {
        haul: round(haulFinal),
        dump: dumpFinal,
        tax: round(taxFinal),
        cc: round(ccFinal),
        total: total,
        overage: round(overage),
        totalWithoutTax: round(total - round(taxFinal)),
        tonLimit: tonLimit,
        version: exports.VERSION,
    };
};
exports.quotedPriceBuild = quotedPriceBuild;
const findMatchingSize = (pricing, selectedMaterial) => {
    const pricingData = pricing.pricingData.find((material) => material.material === selectedMaterial.material);
    const size = pricingData === null || pricingData === void 0 ? void 0 : pricingData.sizes.find((size) => Number(size.size) === selectedMaterial.size);
    return { pricingData: { ...pricingData }, size: { ...size } };
};
exports.findMatchingSize = findMatchingSize;
const findMatchingDiscount = (pricing, selectedMaterial) => {
    const foundDiscountData = pricing.discountData.find((material) => material.material === selectedMaterial.material);
    const foundDiscountSize = foundDiscountData === null || foundDiscountData === void 0 ? void 0 : foundDiscountData.sizes.find((size) => Number(size.size) === selectedMaterial.size);
    return { foundDiscountData, foundDiscountSize };
};
exports.findMatchingDiscount = findMatchingDiscount;
const applyDiscount = (value, discount, type) => {
    const discountValue = {
        [transport_types_1.Pricing.CustomerDiscountType.PERCENTAGE]: (value, discount) => value * (1 - discount * 0.0001),
        [transport_types_1.Pricing.CustomerDiscountType.DOLLAR]: (value, discount) => value - discount,
        [transport_types_1.Pricing.CustomerDiscountType.FIXED]: (_, discount) => discount,
    };
    return discountValue[type](value, discount);
};
exports.applyDiscount = applyDiscount;
const applyDiscountToMaterial = (pricing, discount, tonsAlreadyApplied) => {
    const { size } = pricing;
    const { foundDiscountSize, discounts } = discount;
    if (foundDiscountSize.dump) {
        if (size.dump) {
            size.dump = applyDiscount(size.dump, foundDiscountSize.dump, discounts.discountType);
        }
    }
    if (foundDiscountSize.over) {
        if (size.over) {
            size.over = applyDiscount(size.over, foundDiscountSize.over, discounts.discountType);
        }
    }
    if (foundDiscountSize.haul) {
        size.haul = applyDiscount(size.haul || 0, foundDiscountSize.haul, discounts.discountType);
    }
    if (foundDiscountSize.tonLimit && !tonsAlreadyApplied) {
        size.tonLimit = (size.tonLimit || 0) + foundDiscountSize.tonLimit;
    }
};
exports.applyDiscountToMaterial = applyDiscountToMaterial;
const calculatePricing = (pricing, selectedMaterial, discounts, log = false) => {
    var _a, _b;
    const { pricingData, size } = findMatchingSize(pricing, selectedMaterial);
    if (log)
        console.log(size);
    if (!pricingData) {
        throw new Error('Material not found');
    }
    if (!size) {
        throw new Error('Size not found');
    }
    else {
        if (log)
            console.log(size.tonLimit);
        size.tonLimit = selectedMaterial.weightLimit || size.tonLimit || 0;
        if (selectedMaterial.weightLimit === 0) {
            size.tonLimit = 0;
        }
    }
    if (log)
        console.log(size.tonLimit);
    if (discounts) {
        const { foundDiscountData, foundDiscountSize } = findMatchingDiscount(discounts, selectedMaterial);
        if (foundDiscountData && foundDiscountSize) {
            (0, exports.applyDiscountToMaterial)({ pricingData, size }, { discounts, foundDiscountData, foundDiscountSize }, selectedMaterial.weightLimit != undefined);
        }
    }
    const normalizedPricing = normalizeMaterialSize({
        allowOnlineCheckout: !!pricingData.allowOnlineCheckout,
        doesNotService: !!pricingData.doesNotService,
        material: pricingData.material,
        tax: pricingData.tax,
        type: pricingData.type,
        sizes: [size],
    });
    const normalizedSize = normalizedPricing.sizes[0];
    // console.log('normalized size', normalizedSize);
    // const taxRate = selectedServiceArea.taxJurisdiction === 'NJ' ? 0.06625 : 0; // TODO: Get this from the database, or some third party API
    // const taxRate = selectedMaterial.taxExempt ? 0 : 0.06625;
    let taxRate = 0;
    if (!selectedMaterial.taxExempt) {
        taxRate = (0, exports.findTaxRate)(pricing.serviceAreas[0].taxJurisdiction || '');
        if (pricing.actualTaxRate) {
            taxRate = pricing.actualTaxRate;
        }
        if (selectedMaterial.taxRate) {
            taxRate = selectedMaterial.taxRate;
        }
    }
    let ccRateHardcode = 0.03;
    if (selectedMaterial.creditCardFee || selectedMaterial.creditCardFee === 0) {
        ccRateHardcode = selectedMaterial.creditCardFee;
    }
    const quotedPrice = quotedPriceBuild(normalizedSize.multiplier, normalizedSize.dump, normalizedSize.haul || 0, normalizedSize.tax ? taxRate : 0, ccRateHardcode, (_a = selectedMaterial.roundTotal) !== null && _a !== void 0 ? _a : true, (_b = selectedMaterial.over) !== null && _b !== void 0 ? _b : (normalizedSize.overage || 0));
    if (log)
        console.log(quotedPrice);
    return quotedPrice;
};
exports.calculatePricing = calculatePricing;
//# sourceMappingURL=V1.js.map